export default {
    tickets: {
        columnFilterMenu: false,
        currentPage: 1,
        ticketsData: [],
        tabsData: [],
        pageCount: 0,
        pageNumber: 0,
        pageSize: 50,
        sortColumn: 'ThresholdID',
        sortDirection: 'Desc',
        sortOrders: [],
        startIndex: 0,
        totalPages: null,
        search: null,
        isFilterChecked: true,
        requestForId: '1',
        errorMessage: null,
        errorTitle: null,
        showErrorMessage: false,
        showLoginError: false,
        startTime: Date.now(),
        elapsed: 0,
        filterList: [],
        ticketCheckboxArray: [],
        filtersData: [],
        filterPreviousData: {
            advanceSearchDetails: {},
            isFilterSelectionInProgress: false
        },
        ticketCategoryData: null,
        refreshCategoryGridTime: null,
        columnFilters: [{
            eventName: 'TabFilter',
            isStatus: false,
            groupId: 0,
            parentId: 1,
            id: 2
        },
        {
            eventName: 'ViewFilter',
            isStatus: false,
            groupId: 0,
            parentId: 1,
            id: 3
        },
        {
            eventName: 'saveNewView',
            isStatus: false,
            groupId: 1,
            parentId: 2,
            id: 4
        },
        {
            eventName: 'manageView',
            isStatus: false,
            groupId: 1,
            parentId: 2,
            id: 5
        },
        {
            eventName: 'morePopupView',
            isStatus: false,
            groupId: 0,
            parentId: 1,
            id: 6
        },
        {
            eventName: 'Priority',
            isStatus: false,
            groupId: 1,
            parentId: 1,
            id: 7
        },
        {
            eventName: 'TicketParameter',
            isStatus: false,
            groupId: 1,
            parentId: 1,
            id: 8
        },
        {
            eventName: 'ThresholdStatus',
            isStatus: false,
            groupId: 1,
            parentId: 1,
            id: 9
        },
        {
            eventName: 'Family',
            isStatus: false,
            groupId: 1,
            parentId: 1,
            id: 10
        },
        {
            eventName: 'MSP',
            isStatus: false,
            groupId: 1,
            parentId: 1,
            id: 12
        },
        {
            eventName: 'AssignedTo',
            isStatus: false,
            groupId: 1,
            parentId: 1,
            id: 13
        },
        {
        eventName: 'Cell',
        isStatus: false,
                groupId: 1,
                    parentId:1,
                id:10
        },
                {
        eventName: 'Status',
        isStatus: false,
                groupId: 1,
                    parentId:1,
                id:10
                }
        ],
        showMorePopup: false,
        tabsToBeShown: 4,
        errors: [{
            eventName: 'saveNewTab',
            errorMessage: []
        },
        {
            eventName: 'renameTab',
            errorMessage: []
        }
        ],
        userDetails: null,
        isSticky: false,
        footerPosition: 0,
        dataRequestsTokens: [],
        timers: {
            ticketTechniciansPanel: null,
            notificationsPanel: null
        },
        IsSLM: false,
        IsSLMOwnerTeam:false
    }
};


// WEBPACK FOOTER //
// ./app/initial-state.js